export const GENDER_OPTION = {
  U: "-",
  M: "Male",
  F: "Female",
  N: "Prefer not to say",
} as const;
